import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import wavive_logo from '../../assets/images/logo.png';

function Header({ user, onLogout }) {
    return (
        <header className="admin-header">
            <div className="admin-header-brand">
                <a href="/" className="admin-header-logo">
                    <img src={wavive_logo} alt="Waive Logo" className="me-2" width={108} style={{ 'clip-path': 'border-box' }} />
                </a>
            </div>
            <div className="admin-header-user">
                <FontAwesomeIcon icon="user" className="me-2" />
                <span className="me-3">{user?.username || user?.preferred_username || 'Admin'}</span>
                <button className="btn btn-sm btn-outline-light" onClick={onLogout}>
                    <FontAwesomeIcon icon="sign-out-alt" className="me-1" />
                    Sign out
                </button>
            </div>
        </header>
    );
}

export default Header;
